export const PATHS = {
	AML: 'aml',
	APPROPRIATENESS: 'appropriateness',
	AUTHENTICATE: 'authenticate',
	CREDIT_CHECK: 'credit-check',
	FINISH: 'finish',
	INTERESTS: 'interests',
	MANDATE: 'mandate',
	NETBANK: 'netbank',
	ONBOARD: 'onboard',
	PARENTS: 'parents',
	PRODUCTS: 'products',
	RISKQ_RESULTS: 'riskq-results',
	SIGN: 'sign',
	SIGNING_AUTHORITY: 'signing-authority',
	SUITABILITY: 'suitability'
};
